import { LowerCasePipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { BadgeComponent, ButtonComponent, ProgressBarComponent } from '@core/ui-kit/components';
import { TranslocoPipe } from '@jsverse/transloco';
import { TippyDirective } from '@ngneat/helipopper';

import { AuthStore } from '../../../data-access/data-access-authentication';
import { TokenStore } from '../../../data-access/data-access-token';
import { isDefined } from '../../../utils/is-defined.utils';

@Component({
  selector: 'app-user-membership-recap',
  imports: [
    NgOptimizedImage,
    TranslocoPipe,
    BadgeComponent,
    ProgressBarComponent,
    TippyDirective,
    ButtonComponent,
    LowerCasePipe,
  ],
  templateUrl: './user-membership-recap.component.html',
  styleUrl: './user-membership-recap.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMembershipRecapComponent {
  private readonly tokenStore = inject(TokenStore);
  private readonly authStore = inject(AuthStore);

  tokens = this.tokenStore.tokens;
  totalTokens = this.tokenStore.totalTokens;
  isTrial = this.tokenStore.isTrial;
  subscriptionPlan = this.tokenStore.subscriptionPlan;
  isOrganizationOwner = this.authStore.isOrganizationOwner;

  tokensPercentage = computed(() => {
    const totalTokens = this.totalTokens();
    const tokens = this.tokens();

    if (!isDefined(totalTokens) || !isDefined(tokens)) {
      return 0;
    }

    return (tokens / totalTokens) * 100;
  });

  openBuyTokensDialog(): void {
    this.tokenStore.openBuyTokensDialog();
  }

  openBuyPlanDialog(): void {
    this.tokenStore.openSubscriptionPlansDialog();
  }
}
